module.exports = __webpack_public_path__ + "static/media/nopost.61f87cd5.png";